import { render } from "./LogoView.vue?vue&type=template&id=46868f8f&scoped=true"
import script from "./LogoView.vue?vue&type=script&lang=js"
export * from "./LogoView.vue?vue&type=script&lang=js"

import "./LogoView.vue?vue&type=style&index=0&id=46868f8f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46868f8f"]])

export default __exports__